/* eslint-disable max-len */
import React, { useContext, useEffect } from 'react';
import { Breadcrumb } from '@thd-olt-component-react/etch-widgets/dist/components/etch1/Etch1';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import {
  Accordion, AccordionTitle, AccordionBody, Button, Col, Row, Select
} from '@thd-olt-component-react/core-ui';
import { Metadata } from '@thd-olt-component-react/metadata';
import classnames from 'classnames';
import { BackToTop } from '@thd-olt-component-react/back-to-top';
import { imageBaseUrl } from '../../../constants';
import { PrivacyHeader } from '../PrivacyHeader';
import './Privacy-Overview.scss';
import { PrivacyMetadata } from '../PrivacyMetadata';
import { PrivacySubMenu } from '../PrivacySubMenu';

export const PrivacyOverview = () => {

  const { channel } = useContext(ExperienceContext);

  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('exerciseMyPrivacyRights.static.page-load', {
      pageName: 'privacy and security center>privacy and security at a glance',
      pageType: 'content',
      primaryCategory: 'privacy and security center',
      subCategory1: 'privacy and security center>privacy and security at a glance',
      subCategory2: 'privacy and security center>privacy and security at a glance'
    });
  });

  const navigate = (link) => {
    window.location.href = link;
    return true;
  };

  const handleTableOfContentsChange = (option) => {
    if (option.target.value.startsWith('#')) {
      window.location.hash = option.target.value;
    } else {
      window.location.href = option.target.value;
    }

  };

  const accordionComponent = () => {
    return (
      <Accordion icon={{ position: 'left' }}>
        <AccordionTitle>Learn More</AccordionTitle>
        <AccordionBody key="learnMore-0">
          <Col>
            <p>The tracking tools we use include: </p>
            <br />
            <p><b>Browser cookies,</b> which send text files to your computer or
              device to identify your browser or store information and settings.
            </p>
            <br />
            <p><b>Server logs,</b> which record information about your device, browser, or
              operating system.
            </p>
            <br />
            <p><b>Web beacons and pixels,</b> which collect information about how you
              interact with content.
            </p>
            <br />
            <p><b>Application software,</b> which collects information about how you
              interact with our apps.
            </p>
            <br />
            <p>We use these tools to:</p>
            <br />
            <p><b>Identify new users and recognize returning customers </b></p>
            <br />
            <p><b>Understand how you accessed our digital services and keep you logged in </b>
            </p>
            <br />
            <p><b>Personalize your experience </b></p>
            <br />
            <p><b>Identify your location </b></p>
            <br />
            <p><b>Optimize our websites and apps </b></p>
            <br />
            <p><b>Make product recommendations and provide advertising content </b></p>
            <br />
            <p><b>Better understand our audiences and customers </b></p>
            <br />
            <p><b>Provide correct pricing and ads for your local store </b></p>
            <br />
          </Col>
        </AccordionBody>
      </Accordion>
    );
  };

  const submenuOptions = [
    {
      name: 'Table of Contents',
      value: ''
    },
    {
      name: 'What Information Do We Collect?',
      value: '#WhatInformationDoWeCollect'
    },
    {
      name: 'How Do We Collect Information?',
      value: '#HowDoWeCollectInformation'
    },
    {
      name: 'How Do We Disclose Information?',
      value: '#HowDoWeDiscloseInformation'
    },
    {
      name: 'How Do We Use Information?',
      value: '#HowDoWeUseInformation'
    },
    {
      name: 'Your Privacy Choices',
      value: '#YourPrivacyChoices'
    },
    {
      name: 'Your Security',
      value: '#YourSecurity'
    },
    {
      name: 'Our Tracking Tools',
      value: '#OurTrackingTools'
    },
    {
      name: 'How To Contact Us',
      value: '#HowToContactUs'
    }
  ];

  const metadata = {
    title: 'Privacy and Security At A Glance – The Home Depot',
    description: 'Explore a snapshot of some key parts of The Home Depot’s Privacy and Security Statement.',
    canonical: 'https://www.homedepot.com/privacy/privacy-and-security-at-a-glance'
  };

  const privacyOverviewContentClassname = classnames('margin-20 privacy-overview__content', { 'privacy-overview__content--mobile': channel === 'mobile' });

  return (
    <div style={{ backgroundColor: '#F5F5F5' }} className="privacy-overview">
      <div className="container">
        <Metadata>
          <PrivacyMetadata
            title={metadata.title}
            description={metadata.description}
            canonical={metadata.canonical}
          />
        </Metadata>

        <div className="cdg-content--header">
          <Row>
            <Col>
              <Breadcrumb breadCrumbs={[
                {
                  url: '/privacy/overview',
                  label: 'Privacy & Security Center'
                },
                {
                  url: '',
                  label: 'Privacy & Security at a Glance'
                }]}
              />
            </Col>
          </Row>
        </div>

        <PrivacyHeader privacyInformationActive />

        <div className="cdg-content--body">

          <PrivacySubMenu atAGlanceActive />

          <Row className="white margin-20">
            {channel === 'mobile'
          && (
            <Col md="6" className="remove-padding">
              <img
                width="720"
                height="600"
                alt="Privacy At Homedepot"
                src={imageBaseUrl + '/privacy-security-overview-hero.jpg'}
                style={{ width: '100%' }}
              />
            </Col>
          )}
            <Col md="6">
              <div style={{ paddingLeft: '20px' }}>
                <h1>Privacy & Security at a Glance</h1>
                <br />
                <p style={{ fontSize: '18px' }}>Explore a snapshot of some of the most popular questions customers ask us about how
                  we handle privacy and the information we collect.
                  Read the full <a href="/privacy/privacy-and-security-statement">Privacy & Security Statement</a>
              &nbsp;for more detail about our privacy practices.
                </p>
                <br />
                <p style={{ marginBottom: '10px', fontSize: '18px' }}><b>You can also: </b></p>
                <p style={{ marginBottom: '10px', fontSize: '18px' }}>Send us a request at the&nbsp;
                  <a href="/privacy/exercise-my-privacy-rights">Exercise My Privacy Rights</a> hub.
                </p>
                <p style={{ marginBottom: '10px', fontSize: '18px' }}>
                  Manage how we market to you at&nbsp;
                  <a href="/privacy/MyPreferenceCenter">My Preference Center.</a>
                </p>
                <p style={{ fontSize: '18px' }}><a href="#HowToContactUs">Contact us</a> if you have questions. We&apos;re here to help.</p>
              </div>
            </Col>
            {channel !== 'mobile'
          && (
            <Col md="6" className="remove-padding">
              <img
                width="720"
                height="600"
                alt="Privacy At Homedepot"
                src={imageBaseUrl + '/privacy-security-overview-hero.jpg'}
                style={{ width: '100%' }}
              />
            </Col>
          )}
          </Row>

          <Row />

          <Row className="white margin-20">
            <Col md="4" className="content-summary">
              <h2 className="overview-h2"><b>Information Collection</b></h2>
              <p>There are 3 ways we collect your information: directly from you, passively, and from
                third parties.
              </p>
              <br />
              <br />
              <a href="#WhatInformationDoWeCollect" style={{ fontWeight: 'bold' }}>
                Discover More
                {/* eslint-disable-next-line @mizdra/layout-shift/require-size-attributes */}
                <img
                  src={imageBaseUrl + '/caret-orange.svg'}
                  alt=""
                  style={{ margin: '0 0 1px 5px' }}
                />
              </a>
            </Col>
            <Col md="4" className="content-summary">
              <h2 className="overview-h2"><b>Information Security</b></h2>
              <p>Our goal is to make sure your information is safe and secure.
                We use Secure Sockets Layer (SSL) technology to encrypt and transmit your
                information to our secure server.
              </p>
              <br />
              <a href="#YourSecurity" style={{ fontWeight: 'bold' }}>
                Explore More
                {/* eslint-disable-next-line @mizdra/layout-shift/require-size-attributes */}
                <img
                  src={imageBaseUrl + '/caret-orange.svg'}
                  alt=""
                  style={{ margin: '0 0 1px 5px' }}
                />
              </a>
            </Col>
            <Col md="4" className="content-summary">
              <h2 className="overview-h2"><b>Information Use</b></h2>
              <p>You can manage your marketing preferences at any time or submit a request to review,
                correct or delete your information. You may also opt out of having your personal
                information sold for valuable consideration or shared or used for certain targeted
                advertising. You may also limit the use and disclosure of certain sensitive information
                only to certain purposes permitted under law.
              </p>
              <br />
              <a href="#HowDoWeUseInformation" style={{ fontWeight: 'bold' }}>
                Learn More
                {/* eslint-disable-next-line @mizdra/layout-shift/require-size-attributes */}
                <img
                  src={imageBaseUrl + '/caret-orange.svg'}
                  alt=""
                  style={{ margin: '0 0 1px 5px' }}
                />
              </a>
            </Col>
          </Row>

          {channel === 'mobile'
        && (
          <Row className="cdg-privacy__table-contents-mobile--sticky">
            <Col>
              <Select
                selected=""
                options={submenuOptions}
                onChange={handleTableOfContentsChange}
              />
              <Button style={{ marginTop: '20px' }} outline onClick={() => navigate('/privacy/privacy-and-security-statement')}>Read
                the Full Statement
              </Button>
            </Col>
          </Row>
        )}

          <Row className={privacyOverviewContentClassname}>

            {channel !== 'mobile'
          && (
            <Col md="3" xs="3" lg="3">
              <Row className="cdg-privacy__table-contents cdg-sticky">
                <Col className="white">
                  <h2 className="margin-sides-10"><strong>Table of Contents</strong></h2>
                  <br />
                  <a href="#WhatInformationDoWeCollect">What Information Do We Collect?</a>
                  <a href="#HowDoWeCollectInformation">How Do We Collect Information?</a>
                  <a href="#HowDoWeDiscloseInformation">How Do We Disclose Information?</a>
                  <a href="#HowDoWeUseInformation">How Do We Use Information?</a>
                  <a href="#YourPrivacyChoices">Your Privacy Choices</a>
                  <a href="#YourSecurity">Your Security</a>
                  <a href="#OurTrackingTools">Our Tracking Tools</a>
                  <a href="#HowToContactUs">How To Contact Us</a>
                  <Button outline onClick={() => navigate('/privacy/privacy-and-security-statement')}>Read
                    the Full Statement
                  </Button>
                </Col>
              </Row>
            </Col>
          )}

            <Col md="9" xs="9" lg="9">
              <Row>
                <Col className="white">
                  <div className="margin-10">
                    <h3 className="overview-h3" id="WhatInformationDoWeCollect">What Information Do We Collect?</h3>
                    <br />
                    <p>We collect your information to provide the most seamless and personalized
                      shopping
                      experience possible. Here are examples of the information we collect:
                    </p>
                    <br />
                    <p><b>Identifiers,</b> including name, email address, phone number,
                      username, physical address, and more.
                    </p>
                    <br />
                    <p><b>Demographic information,</b> including age, race, ethnicity, and gender. </p>
                    <br />
                    <p><b>Internet activity,</b> including browsing history, search history, and
                      information about your activities when using our in-store Wi-Fi.
                    </p>
                    <br />
                    <p><b>Commercial Information,</b> including products or services purchased, reviews, and
                      where you shop.
                    </p>
                    <br />
                    <p><b>Payment information,</b> including credit or debit card, check, PayPal,
                      commercial credit account, or gift card.
                    </p>
                    <br />
                    <p><b>Location information,</b> including IP address or mobile device location
                      information.
                    </p>
                    <br />
                    <p><b>Employment information,</b> including your profession, trade, or line of
                      business.
                    </p>
                    <br />
                    <p><b>Video and audio recordings,</b> including in-store CCTV and customer care
                      calls.
                    </p>
                    <br />
                    <p><b>Biometric information,</b> including facial recognition. </p>
                    <br />
                    <p><b>Property information,</b> including home and property measurements, square
                      footage, and ownership information.
                    </p>
                    <br />
                    <p><b>Inferences,</b> including preferences, interests and other characteristics. </p>
                    <br />
                    <p>
                      We may also collect some information that may be considered sensitive under
                      certain privacy laws, including, in certain cases, account login credentials,
                      race/ethnicity, government identification numbers, biometrics, and precise geo-location.
                    </p>
                    <br />
                    <p>You can read more about what information we collect in our full&nbsp;
                      <a href="/privacy/privacy-and-security-statement">Privacy and Security Statement</a>.
                    </p>
                    <br />
                    <br />

                    <h3 className="overview-h3" id="HowDoWeCollectInformation">How Do We Collect Information?</h3>
                    <br />
                    <p>There are 3 ways we collect your information:</p>
                    <br />
                    <p><b>We collect information directly from you. </b>
                      You provide us with your information when you visit our stores,
                      register for an account, make an online purchase, or rent equipment.
                    </p>
                    <br />
                    <p><b>We collect information from you passively. </b>
                      We use tools like cookies to
                      collect information when you use our websites or interact with our emails.
                    </p>
                    <br />
                    <p><b>We collect information from affiliates and third parties. </b>
                      This includes shipping companies, installers, service providers, social media platforms, and more.
                    </p>
                    <br />
                    <p>You can read more about how we collect your information in our full&nbsp;
                      <a href="/privacy/privacy-and-security-statement">Privacy and Security Statement</a>.
                    </p>
                    <br />
                    <br />

                    <h3 className="overview-h3" id="HowDoWeDiscloseInformation">How Do We Disclose Information?</h3>
                    <br />
                    <p>We may disclose your information with select third parties for our business
                      purposes or as legally required. Some examples include:
                    </p>
                    <br />
                    <p><b>We disclose your information with vendors we work with,</b> including delivery
                      service
                      providers, shipping and mailing vendors, and warranty service providers.
                    </p>
                    <br />
                    <p><b>We disclose your information with financial services companies,</b> including The Home
                      Depot
                      Credit Card and home improvement loans.
                    </p>
                    <br />
                    <p><b>We disclose or share your information with advertising and marketing partners</b> to
                      manage and deliver advertising and understand your preferences. We may disclose or share
                      information that does not directly identify you (such as your device
                      identifier, IP address, or other information associated with your online
                      browsing activities) with select third parties for their and our advertising
                      and marketing efforts.
                    </p>
                    <br />
                    <p><b>We disclose your information to prevent fraud</b> or collect debts.</p>
                    <br />
                    <p><b>We disclose your information at your request, </b>
                      such as providing your information to a third party, such as an installer
                      or joint marketing partner that you direct us to share it with.
                    </p>
                    <br />
                    <p>You can read more about how we disclose or share your information in our full&nbsp;
                      <a href="/privacy/privacy-and-security-statement">Privacy and Security Statement</a>. To
                      exercise your privacy rights, please visit:&nbsp;
                      <a href="/privacy/Exercise-My-Privacy-Rights">Exercise My Privacy Rights</a>.
                    </p>
                    <br />
                    <br />

                    <h3 className="overview-h3" id="HowDoWeUseInformation">How Do We Use Information?</h3>
                    <br />
                    <p>We use your information to improve your experience, process your information,
                      and keep things running smoothly.
                    </p>
                    <br />
                    <p><b>We provide you with products,</b> including order fulfillment, contest or
                      sweepstakes entries, registration, returns, and product reviews.
                    </p>
                    <br />
                    <p><b>We improve our business, products, and services,</b> including optimizing our
                      websites and apps and improving store layouts and purchasing experiences.
                    </p>
                    <br />
                    <p><b>We personalize your experience,</b> including recommending products and
                      updating inventory to match demand.
                    </p>
                    <br />
                    <p><b>We monitor for fraud and asset protection purposes, </b> including processing and tracking returns
                      and confirming the identity of customers renting tools and equipment.
                    </p>
                    <br />
                    <p><b>We advertise to you,</b> including supporting targeted advertising for select
                      third parties and sending you promotions, newsletters, and information from other
                      select companies we think you might find interesting.
                    </p>
                    <br />
                    <p>You can read more about how we use your information in our full&nbsp;
                      <a href="/privacy/privacy-and-security-statement">Privacy and Security Statement</a>.
                    </p>
                    <br />
                    <br />

                    <h3 className="overview-h3" id="YourPrivacyChoices">Your Privacy Choices</h3>
                    <br />
                    <p>You can <a href="/privacy/MyPreferenceCenter"> manage your marketing preferences</a> to tell us how you would like
                      to receive our marketing communications, including email, calls, text messages, direct mail,
                      and catalog mailings. Please allow sufficient time for your preferences to be updated. You
                      can read more about managing your marketing preferences in our full&nbsp;<a href="/privacy/privacy-and-security-statement">Privacy and Security Statement</a>.
                    </p>
                    <br />
                    <p>
                      You may submit a privacy request to review, correct, or delete the personal information we collect;
                      opt out of having your personal information sold for valuable consideration or for being shared or
                      used for certain targeted advertising; or limit the use of certain sensitive personal information.
                      To exercise your privacy rights, please visit: <a href="/privacy/Exercise-My-Privacy-Rights"> Exercise My Privacy Rights</a>.
                    </p>
                    <br />
                    <br />

                    <h3 className="overview-h3" id="YourSecurity">Your Security</h3>
                    <br />
                    <p>Our goal is to make sure your information is safe and secure. We use Secure
                      Sockets Layer (SSL) technology to encrypt and transmit your information to our
                      secure server. SSL technology, an industry standard, is designed to prevent
                      someone other than operators of our websites from capturing and viewing your
                      personal information.
                    </p>
                    <br />
                    <p>
                      However, no security measures are perfect. We cannot promise that our websites
                      or
                      apps will be completely safe. Since access to personal information in your account(s) is
                      protected with a password, we recommend choosing a unique password and avoid
                      sharing it with anyone.
                    </p>
                    <br />
                    <p>You can read more about our security measures in our full&nbsp;
                      <a href="/privacy/privacy-and-security-statement">Privacy and Security Statement</a>.
                    </p>
                    <br />
                    <br />

                    <h3 className="overview-h3" id="OurTrackingTools">Our Tracking Tools</h3>
                    <br />
                    <p>
                      In order to collect your information online, we use digital tracking tools,
                      including cookies and web beacons. The third-party companies we partner with
                      might also use tracking tools on their web properties. You can control our
                      tracking tools by disabling browser cookies.
                    </p>
                    <br />
                    {accordionComponent()}
                    <br />
                    <p>You can read more about our tracking tools in our full&nbsp;
                      <a href="/privacy/privacy-and-security-statement">Privacy and Security Statement</a>.
                    </p>
                    <br />
                    <br />

                    <h3 className="overview-h3" id="HowToContactUs">How to Contact Us</h3>
                    <br />
                    <p>You can contact us about our <a href="/privacy/privacy-and-security-statement">Privacy and Security Statement</a> using one of the
                      below:
                    </p>
                    <br />
                    <ul>
                      <li>Call us at <a href="tel:18004663337">1-800-HOME-DEPOT (1-800-466-3337)</a></li>
                      <li>Email us at <a href="mailto:privacy@homedepot.com">privacy@homedepot.com</a>
                      </li>
                      <li>Write to us at: The Home Depot, Privacy Official Customer Care, 2455 Paces
                        Ferry Road, Atlanta, GA 30339
                      </li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="margin-20" />
          <BackToTop />
        </div>
      </div>
    </div>
  );
};

PrivacyOverview.propTypes = {};

PrivacyOverview.defaultProps = {};
